class SimpleSessionTimer {
  constructor() {
    this.checkInterval = null;
    this.warningShown = false;
    this.sessionDuration = 1 * 60 * 60 * 1000; // 1 hours in milliseconds
    this.warningTime = 5 * 60 * 1000; // 5 minutes before expiry
  }

  // Start session timer
  startSession() {
    // Store login time in localStorage
    const loginTime = Date.now();
    localStorage.setItem('sessionStartTime', loginTime.toString());
    
    console.log('Session timer started at:', new Date(loginTime));
  }

  // Start monitoring session expiration
  startMonitoring(onExpired, onWarning) {
    this.stopMonitoring(); // Clear any existing monitoring
    this.warningShown = false;
    
    this.checkInterval = setInterval(() => {
      const sessionStartTime = localStorage.getItem('sessionStartTime');
      
      if (!sessionStartTime) {
        console.log('No session start time found');
        this.handleSessionExpired(onExpired);
        return;
      }

      const startTime = parseInt(sessionStartTime);
      const currentTime = Date.now();
      const sessionAge = currentTime - startTime;
      const timeRemaining = this.sessionDuration - sessionAge;

      console.log('Session age:', Math.floor(sessionAge / 60000), 'minutes');
      console.log('Time remaining:', Math.floor(timeRemaining / 60000), 'minutes');

      if (timeRemaining <= 0) {
        console.log('Session has expired');
        this.handleSessionExpired(onExpired);
        return;
      }

      if (timeRemaining <= this.warningTime && !this.warningShown) {
        console.log('Session is about to expire');
        this.handleSessionWarning(timeRemaining, onWarning);
      }
    }, 30000); // Check every 30 seconds
  }

  // Stop monitoring
  stopMonitoring() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
    this.warningShown = false;
  }

  // Handle session expiration
  handleSessionExpired(onExpired) {
    this.stopMonitoring();
    
    // Clear session data
    localStorage.removeItem('sessionStartTime');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userData');
    
    // Clear global state
    const { Globals } = require('../globalfunctions.js');
    Globals.UserName = '';
    Globals.UserType = '';
    Globals.LoginTime = null;
    Globals.FirstName = '';
    Globals.LastName = '';
    
    if (onExpired) {
      onExpired();
    } else {
      // Default behavior
      const { closeAllDialogs, alertDialog } = require('./dialogs');
      closeAllDialogs();
      alertDialog('Your session has expired. Please log in again.').then(() => { window.location.href = '/login'; });
    }
  }

  // Handle session warning
  handleSessionWarning(timeRemaining, onWarning) {
    this.warningShown = true;
    
    if (onWarning) {
      onWarning(timeRemaining);
    } else {
      // Default warning behavior
      const minutes = Math.ceil(timeRemaining / 60000);
      const { confirmDialog } = require('./dialogs');
      confirmDialog(
        `Your session will expire in ${minutes} minute${minutes > 1 ? 's' : ''}. Stay signed in?`,
        { title: 'Session expiring', confirmLabel: 'Stay signed in', cancelLabel: 'Log out' }
      ).then((continueSession) => {
        if (!continueSession) {
          this.handleSessionExpired();
        } else {
          // Reset warning flag to show again if still about to expire
          setTimeout(() => {
            this.warningShown = false;
          }, 60000); // Reset after 1 minute
        }
      });
    }
  }

  // Extend session (reset timer)
  extendSession() {
    const loginTime = Date.now();
    localStorage.setItem('sessionStartTime', loginTime.toString());
    this.warningShown = false;
    console.log('Session extended at:', new Date(loginTime));
  }

  // Get remaining session time
  getRemainingTime() {
    const sessionStartTime = localStorage.getItem('sessionStartTime');
    if (!sessionStartTime) return 0;
    
    const startTime = parseInt(sessionStartTime);
    const currentTime = Date.now();
    const sessionAge = currentTime - startTime;
    const timeRemaining = this.sessionDuration - sessionAge;
    
    return Math.max(0, timeRemaining);
  }

  // Format remaining time for display
  formatTimeRemaining(milliseconds) {
    if (milliseconds <= 0) return '0 minutes';
    
    const minutes = Math.ceil(milliseconds / 60000);
    const hours = Math.floor(minutes / 60);
    
    if (hours > 0) {
      const remainingMinutes = minutes % 60;
      return `${hours} hour${hours > 1 ? 's' : ''}${remainingMinutes > 0 ? ` and ${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}` : ''}`;
    }
    
    return `${minutes} minute${minutes > 1 ? 's' : ''}`;
  }

  // Check if session is still valid
  isSessionValid() {
    const sessionStartTime = localStorage.getItem('sessionStartTime');
    if (!sessionStartTime) return false;
    
    const startTime = parseInt(sessionStartTime);
    const currentTime = Date.now();
    const sessionAge = currentTime - startTime;
    
    return sessionAge < this.sessionDuration;
  }

  // Clear session
  clearSession() {
    this.stopMonitoring();
    localStorage.removeItem('sessionStartTime');
  }
}

const simpleSessionTimer = new SimpleSessionTimer();
export default simpleSessionTimer;